<template>
  <div>
    <div class="gray-bg">
      <main-header/>
    </div>
    <div v-if="isLoaded">
      <div v-if="moreProducts.length === 0">
        <v-alert
            text
            type="error"
        >
          محصولی یافت نشد
        </v-alert>
      </div>
      <more-products v-else :productsArray="moreProducts" page-title="پرفروش ترین ها"/>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainHeader from "./mainHeader";
import MoreProducts from "./moreProducts";

let _this = null;

export default {
  name: "selectedMoreProducts",
  components: {MainHeader, MoreProducts},
  data: () => ({
    moreProducts: [],
    isLoaded: false,
    showLoaderDialog: false,
  }),
  mounted() {
    _this = this;
    this.getData();
    console.log("Mounted");
  },
  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      var urlencoded = new URLSearchParams();

      var requestOptions = {
        method: 'POST',
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/SearchEngine/ShowAllSelectedProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            _this.moreProducts = JSON.parse(result)
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));

    }
  }

}
</script>

<style scoped>

</style>
